const SuspendRender = ({ isLoading, loadingComponent, children, render }) => {
  if (render) {
    return isLoading ? loadingComponent : render();
  }
  return isLoading ? loadingComponent : children;
};

export default SuspendRender;
